import { Controller } from "@hotwired/stimulus";
import { showNotice } from "../services/notice_service";

export default class extends Controller {
  playerChanged(event) {
    const { value } = event.target;
    const url = event.currentTarget.dataset.galleryItemUrlParam;
    if (!url) {
      showNotice("Unable to update player");
      return;
    }

    $.ajax(url, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
      },
      dataType: "json",
      data: { player_id: value },
    })
      .then((result) => {
        if (result.error) {
          showNotice(result.error);
        }

        if (result.individuals_name) {
          $('#individuals_name').text(result.individuals_name);
        }
      })
      .catch(() => {
        showNotice("Something went wrong");
      });
  }
}
